import React from 'react';

function ErrorPageSEO() {
  return <meta name="description" content="404 Error. Sorry this page was not found" />;
}
export default ErrorPageSEO;
